import { render, staticRenderFns } from "./modulesView.vue?vue&type=template&id=6a68bdf9"
import script from "./modulesView.vue?vue&type=script&lang=js"
export * from "./modulesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports